import type { StateAction } from "@entrilia/shared/types";

export type FieldsSectionId = "chartOfAccounts" | "dimensions" | "measures";

export interface FieldsSectionState {
  open: boolean;
  groupsOpen: boolean;
  groupsEpoch: number;
}

export interface FieldsSectionControl extends FieldsSectionState {
  onToggle: () => void;
}

export type FieldsExpansionState = Record<FieldsSectionId, FieldsSectionState>;

const openSection: FieldsSectionState = { open: true, groupsOpen: false, groupsEpoch: 0 };

export const initialFieldsExpansionState: FieldsExpansionState = {
  chartOfAccounts: openSection,
  dimensions: openSection,
  measures: openSection,
};

const mapSections = (
  state: FieldsExpansionState,
  update: (section: FieldsSectionState) => FieldsSectionState
): FieldsExpansionState => ({
  chartOfAccounts: update(state.chartOfAccounts),
  dimensions: update(state.dimensions),
  measures: update(state.measures),
});

export const areAllSectionsOpen = (state: FieldsExpansionState): boolean =>
  state.chartOfAccounts.open && state.dimensions.open && state.measures.open;

export const toggleSectionAction =
  (id: FieldsSectionId): StateAction<FieldsExpansionState> =>
  (state) => {
    const section = state[id];
    const toggled: FieldsSectionState = section.open
      ? { ...section, open: false }
      : { open: true, groupsOpen: false, groupsEpoch: section.groupsEpoch + 1 };
    return { ...state, [id]: toggled };
  };

export const toggleAllSectionsAction: StateAction<FieldsExpansionState> = (state) =>
  mapSections(state, (section) =>
    areAllSectionsOpen(state)
      ? { ...section, open: false }
      : { open: true, groupsOpen: true, groupsEpoch: section.groupsEpoch + 1 }
  );
